export const siteSettings = {
  name: "Hexa Finex",
  link: "https://hexafinex.live",
  email: "support@hexafinex.live",
  appLink: "https://app.hexafinex.live",
};
